import React, {Component} from "react";
import {Select} from "antd";
import {organizationApiService} from "../../services/robofin/OrganizationApiService";

class BankSelect extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);

        this.initState = {
            listRobofinBank: [],
            dataBank: [],
            selectBankValue: null,
            loadingFetchData: false,
        };
        this.state = {...this.initState};
    }

    fetchBankData = async () => {
        this.promisedSetState({loadingFetchData: true})
        try {
            const listRobofinBank = await organizationApiService.getPoplarBank();
            const dataForState: any = listRobofinBank?.data?.data?.map((bank: any) => ({
                value: bank?.SK,
                name: bank?.Name,
            }));
            this.setState({
                listRobofinBank: listRobofinBank?.data?.data,
                dataBank: dataForState,
                loadingFetchData: false,
            })
        } catch (e: any) {
            console.log(e)
            this.setState({
                loadingFetchData: false,
            })
        }
    };

    onChange = (value: any, option: any) => {
        this.setState({selectBankValue: value,});
        const picked = this?.state?.listRobofinBank?.find((o: { SK: any; }) => o.SK === value);
        option.short_name = picked?.ShortName;
        option.name = picked?.Name;
        this.props.onBankChangeProps(option);
    };

    onValueChange = (value: any) => {
        this.setState({
            selectBankValue: value,
        });
    };

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.value !== prevProps.value) {
            this.onValueChange(this.props.value);
        }
    }

    async componentDidMount() {
        this.fetchBankData();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <Select
                disabled={this.props?.disable ? this.props?.disable : false}
                showSearch
                placeholder="Pilih Bank"
                optionFilterProp="children"
                onChange={this.onChange}
                loading={this.state.loadingFetchData}
                style={{width: "100%"}}
                filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                value={this.props.value}
            >
                {this.state.dataBank.map((item: any, i: number) => (
                    <Select.Option key={i} value={item?.value}>
                        {item?.name}
                    </Select.Option>
                ))}
            </Select>
        );
    }
}

export default BankSelect;